import { FormControlLabel, styled, CSSObject } from '@mui/material'

export const ToggleFormControlLabel = styled(FormControlLabel)<{ error?: boolean }>(({ theme, error }) => ({
  marginLeft: 0,
  justifyContent: 'space-between',
  width: '100%',
  color: error ? theme.palette.error[500] : 'currentColor',
  ...(theme.typography['Lato Caption'] as CSSObject),
}))
